import React, { useState } from 'react'
import { Box, Typography } from '@material-ui/core'
import { useStyles } from './SubscriptionFormFields.styles'
import { useGlobalStyles } from 'src/mui/styles/globalStyles'

type Props = {
  errorMessage: React.ReactNode
}

const SubscriptionFormFields: React.FC<Props> = ({ errorMessage }) => {
  const classes = useStyles()
  const globalClasses = useGlobalStyles()
  const year = new Date().getFullYear()
  const getYearsFrom = (startYear: number, lastYear: number) => {
    const years: number[] = []
    for (let i = startYear; i <= lastYear; i++) {
      years.push(i)
    }
    return years
  }
  const getYearOptions = (years: number[]) =>
    years.reverse().map((year, index) => (
      <option key={`year-${index}`} value={`${year}-1-1`}>
        {year}
      </option>
    ))
  const onlyNumbers = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault()
    }
  }
  const [yearsEndDate, setYearsEndDate] = useState(
    getYearOptions(getYearsFrom(year - 70, year))
  )
  const updateEndDate = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedYear = parseInt(event.target.value.substring(0, 4))
    setYearsEndDate(getYearOptions(getYearsFrom(selectedYear, year)))
  }

  return (
    <>
      <Typography
        variant="h3"
        id="sub-form-id-anchor"
        className={globalClasses.titleSectionVariant2}
      >
        Identificação
      </Typography>
      <Typography className={classes.paragraph}>
        Preencha os campos abaixo com seus dados pessoais:
      </Typography>
      {errorMessage && (
        <Box className={classes.errorWrapper}>{errorMessage}</Box>
      )}
      <Box className={classes.field}>
        <label htmlFor="FullName" className={classes.label}>
          Nome Completo *
        </label>
        <input
          className={classes.input}
          type="text"
          id="FullName"
          name="FullName"
          maxLength={100}
          required
        />
      </Box>
      <Box className={classes.field}>
        <label htmlFor="SocialName" className={classes.label}>
          Nome Social
        </label>
        <input
          className={classes.input}
          type="text"
          id="SocialName"
          name="SocialName"
          maxLength={100}
        />
      </Box>
      <Box className={classes.fieldGroup}>
        <Box className={classes.field}>
          <label htmlFor="RG" className={classes.label}>
            RG *
          </label>
          <input
            className={classes.input}
            type="tel"
            id="RG"
            name="RG"
            pattern="[0-9]*"
            onKeyPress={onlyNumbers}
            placeholder="Digite o seu RG (apenas números)"
            maxLength={30}
            required
          />
        </Box>
        <Box className={classes.field}>
          <label htmlFor="CPF" className={classes.label}>
            CPF *
          </label>
          <input
            className={classes.input}
            type="tel"
            id="CPF"
            name="CPF"
            pattern="[0-9]*"
            minLength={11}
            maxLength={11}
            onKeyPress={onlyNumbers}
            placeholder="Digite o seu CPF (apenas números)"
            required
          />
        </Box>
      </Box>
      <Box className={classes.field}>
        <label htmlFor="Address" className={classes.label}>
          Endereço *
        </label>
        <input
          className={classes.input}
          type="text"
          id="Address"
          name="Address"
          maxLength={120}
          required
        />
      </Box>
      <Box className={classes.fieldGroup}>
        <Box className={classes.field}>
          <label htmlFor="City" className={classes.label}>
            Cidade *
          </label>
          <input
            className={classes.input}
            type="text"
            id="City"
            name="City"
            maxLength={60}
            required
          />
        </Box>
        <Box className={classes.field}>
          <label htmlFor="State" className={classes.label}>
            Estado *
          </label>
          <input
            className={classes.input}
            type="text"
            id="State"
            name="State"
            maxLength={60}
            required
          />
        </Box>
        <Box className={classes.field}>
          <label htmlFor="Country" className={classes.label}>
            País *
          </label>
          <input
            className={classes.input}
            type="text"
            id="Country"
            name="Country"
            maxLength={60}
            required
          />
        </Box>
      </Box>
      <Box className={classes.fieldGroup}>
        <Box className={classes.field}>
          <label htmlFor="Email" className={classes.label}>
            E-mail *
          </label>
          <input
            className={classes.input}
            type="email"
            id="Email"
            name="Email"
            maxLength={30}
            required
          />
        </Box>
        <Box className={classes.field}>
          <label htmlFor="Phone" className={classes.label}>
            Celular *
          </label>
          <input
            className={classes.input}
            type="tel"
            id="Phone"
            name="Phone"
            pattern="[0-9]*"
            onKeyPress={onlyNumbers}
            placeholder="Digite o seu número de telefone"
            maxLength={30}
            required
          />
        </Box>
      </Box>
      <Box className={classes.separator} />
      <Typography variant="h3" className={globalClasses.titleSectionVariant2}>
        Informações Acadêmicas
      </Typography>
      <Typography className={classes.paragraph}>
        Preencha os campos abaixo com as suas informações acadêmicas.
      </Typography>
      <Box className={classes.field}>
        <label htmlFor="CourseName" className={classes.label}>
          Nome do Curso Superior *
        </label>
        <input
          className={classes.input}
          type="text"
          id="CourseName"
          name="CourseName"
          maxLength={100}
          required
        />
      </Box>
      <Box className={classes.field}>
        <label htmlFor="EducationalInstitution" className={classes.label}>
          Instituição de Ensino *
        </label>
        <input
          className={classes.input}
          type="text"
          id="EducationalInstitution"
          name="EducationalInstitution"
          maxLength={100}
          required
        />
      </Box>
      <Box className={classes.fieldGroup}>
        <Box className={classes.field}>
          <label htmlFor="CourseStartDate" className={classes.label}>
            Ano de Início do Curso *
          </label>
          <select
            className={classes.inputDate}
            id="CourseStartDate"
            name="CourseStartDate"
            onChange={updateEndDate}
            required
          >
            {getYearOptions(getYearsFrom(year - 70, year))}
          </select>
        </Box>
        <Box className={classes.field}>
          <label htmlFor="CourseEndDate" className={classes.label}>
            Ano de Conclusão do Curso *
          </label>
          <select
            className={classes.inputDate}
            id="CourseEndDate"
            name="CourseEndDate"
            required
          >
            {yearsEndDate}
          </select>
        </Box>
      </Box>
    </>
  )
}

export default SubscriptionFormFields
